<template>
  <Breadcrumbs
      title="Create New Item"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Items', path: '/items' },
      { label: 'Create New Item', path: '/create-item' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <createItemForm/>
    </div>
  </div>
</template>

<script>
import createItemForm from "@/pages/master_data/items/items/createItemForm.vue";

export default {
  name: 'createItem',
  components: {
    createItemForm,
  },
}
</script>
